import axiosInstance, { errorHandler } from "./api";

const MERCHANTS_URL = "/localmapservice/api/v1/merchants";

const convertCoordinatesToGoogleMaps = merchant => ({
  ...merchant,
  coordinates: {
    lat: merchant.coordinates.lat,
    lng: merchant.coordinates.lon,
  },
});

const convertSort = sort => {
  if (sort) {
    const sortWords = sort.split(",");
    return `${sortWords[0]},${sortWords[1]}`;
  }

  return null;
};

// No permission
const getMerchants = axios => (page, size, search, sort, category) =>
  axios
    .get(`${MERCHANTS_URL}`, {
      params: {
        search,
        category,
        page,
        size,
        sort: convertSort(sort),
      },
    })
    .then(({ data, headers }) => ({
      data: data.content,
      total: Number(data.totalElements),
    }))
    .catch(errorHandler);

// No permission
const getMerchantRequests = axios => (
  page,
  size,
  search,
  sort = "id,desc",
  status,
) =>
  axios
    .get(`${MERCHANTS_URL}/requests`, {
      params: {
        search,
        status,
        page,
        size,
        sort,
      },
    })
    .then(({ data, headers }) => ({
      data: data,
      total: Number(headers["x-total-count"]),
    }))
    .catch(errorHandler);

// No permission
const getMerchantInfo = axios => id =>
  axios
    .get(`${MERCHANTS_URL}/${id}`)
    .then(({ data }) => ({ data: convertCoordinatesToGoogleMaps(data) }))
    .catch(errorHandler);

// No permission
const getMerchantRequestInfo = axios => id =>
  axios
    .get(`${MERCHANTS_URL}/requests/${id}`)
    .then(({ data }) => ({ data: convertCoordinatesToGoogleMaps(data) }))
    .catch(errorHandler);

// No permission
const getMerchantImage = axios => uuid =>
  axios
    .get(`${MERCHANTS_URL}/image`, { params: { uuid } })
    .then(({ data }) => data)
    .catch(errorHandler);

// No permission
const getMerchantRequestImage = axios => uuid =>
  axios
    .get(`${MERCHANTS_URL}/requests/image`, { params: { uuid } })
    .then(({ data }) => data)
    .catch(errorHandler);

// No permission
const addMerchant = axios => merchant =>
  axios
    .post(`${MERCHANTS_URL}/requests/create`, merchant)
    .then(({ data }) => ({ data }))
    .catch(errorHandler);

// No permission
const updateMerchant = axios => merchant =>
  axios
    .post(`${MERCHANTS_URL}/requests/update`, merchant)
    .then(({ data }) => ({ data }))
    .catch(errorHandler);

// No permission
const deleteMerchant = axios => id =>
  axios
    .post(`${MERCHANTS_URL}/requests/delete/${id}`)
    .then(({ data }) => ({ data }))
    .catch(errorHandler);

// No permission
const approveMerchantRequest = axios => id =>
  axios
    .post(`${MERCHANTS_URL}/requests/approve`, {
      id,
    })
    .then(({ data }) => ({ data }))
    .catch(errorHandler);

// No permission
const rejectMerchantRequest = axios => id =>
  axios
    .post(`${MERCHANTS_URL}/requests/reject`, {
      id,
    })
    .then(({ data }) => ({ data }))
    .catch(errorHandler);

// No permission
const getMerchantTypes = axios => () =>
  axios
    .get(`${MERCHANTS_URL}/types`)
    .then(({ data }) => ({
      data,
    }))
    .catch(errorHandler);

export default {
  getMerchants: getMerchants(axiosInstance),
  getMerchantRequests: getMerchantRequests(axiosInstance),
  getMerchantRequestInfo: getMerchantRequestInfo(axiosInstance),
  getMerchantTypes: getMerchantTypes(axiosInstance),
  getMerchantInfo: getMerchantInfo(axiosInstance),
  getMerchantImage: getMerchantImage(axiosInstance),
  getMerchantRequestImage: getMerchantRequestImage(axiosInstance),
  addMerchant: addMerchant(axiosInstance),
  updateMerchant: updateMerchant(axiosInstance),
  deleteMerchant: deleteMerchant(axiosInstance),
  approveMerchantRequest: approveMerchantRequest(axiosInstance),
  rejectMerchantRequest: rejectMerchantRequest(axiosInstance),
};
